import React, {useState, useEffect} from 'react';
import "./Card.css";
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function TeamSettingsCard({team}) 
{
    const { app_user, team_member_role, setUserDisplayRefresh, setTeamDisplayRefresh } = useCTAL();

    const [error, setError] = useState();
    const [form_changed_flag, setFormChangedFlag] = useState(false);
    const [update_team_settings_button_type, setUpdateTeamSettingsButtonType] = useState("btn btn-sm btn-secondary mt-2");
    const [admin_message_display, setAdminMessageDisplay] = useState(<></>); 

    const admin_message_style = { color: 'red' };

    useEffect(() =>
    {
        if (DEBUG) console.log(`TeamSettingsCard - form_changed_flag: ${form_changed_flag}`);
        if (!form_changed_flag)
            setUpdateTeamSettingsButtonType("btn btn-sm btn-secondary mt-2");
        else
            setUpdateTeamSettingsButtonType("btn btn-sm btn-primary mt-2");
    }, [form_changed_flag]);
    
    useEffect(() =>
    {
        if (!team) return;

        var is_disabled = true;
        if (team_member_role == "Admin") {
            is_disabled = false;
            setAdminMessageDisplay(<></>);
        }
        else setAdminMessageDisplay(<><span style={admin_message_style}><small>Modifying Settings requires Team Admin privileges</small></span></>)
        
        document.getElementById("team-settings-desc").disabled = is_disabled;
        document.getElementById("team-settings-prefix").disabled = is_disabled;
    }, [team]);

    const send_team_settings_update = (body) => { 
        console.log(`TeamSettingsCard - Send Team Settings Update, body: ${body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-upd`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
            .then(() => setUserDisplayRefresh(true))
            .then(() => setTeamDisplayRefresh(true))
            .catch(setError);
    }

    const create_team_settings_update = () => { 
        if ((!team) || (!app_user)) return;
        if (!form_changed_flag) return;

        var type = "update_team_settings";
        var team_id            = team.TeamID;
        var user_id            = app_user.UserID;
        var user_full_name     = app_user.UserFullName;
        var desc               = document.getElementById("team-settings-desc").value;
        var action_item_prefix = document.getElementById("team-settings-prefix").value;

        var body = JSON.stringify({type, team_id, user_id, user_full_name, desc, action_item_prefix});

        send_team_settings_update(body);

        setFormChangedFlag(false);
    }
    
    const form_changed = () => { 
        setFormChangedFlag(true);
    }

    return (
        <div class="card mt-2">
            <div id="team-settings-card-header" class="card-header">
                <div class="row">
                    <div id="team-settings-title" class="col text-start">
                        <a href="#"><img class="card-icon" src="./images/settings.svg" alt="history" border="0"/></a>
                        <span className="card-sub-title">Team Settings</span>
                    </div>
                </div>
            </div>
            <div class="card-body">
                
                {admin_message_display}

                <div class="input-group input-group-sm" required>
                    <span class="input-group-text" >Team Name</span>
                    <input id="team-settings-name" disabled type="text" class="form-control" placeholder="Team Name" defaultValue={team.TeamName} aria-label="TeamName" aria-describedby="team-name"/>
                </div>
                <div class="form-floating mt-1">
                    <textarea id="team-settings-desc" class="form-control" placeholder="Team Description" defaultValue={team.TeamDescription} onChange={form_changed}></textarea>
                    <label class="select-floating-label" htmlFor="floatingSelect">Team Description</label>
                </div>
                <div class="input-group input-group-sm mt-1">
                    <span class="input-group-text">Action Prefix (ex. CTAL-)</span>
                    <input id="team-settings-prefix" type="text" class="form-control" placeholder="Action Prefix (1-4 letters)" defaultValue={team.ActionIDPrefix} aria-label="ActionItemPrefix" aria-describedby="team-ai-prefix" onChange={form_changed}/>
                </div>
                <div class="row">
                    <div class="col text-end">                      
                        <a href="#" class={update_team_settings_button_type} onClick={ () => create_team_settings_update() }>Update Team Settings</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
